import React from "react";
import {
    Edit,
    SimpleForm,
    TextInput,
    Loading,
} from "react-admin";
import Grid from '@material-ui/core/Grid';
import WithProps from "../../Custom/WithProps";
import { makeStyles } from '@material-ui/core/styles';
import { CustomBooleanInput, EditToolBar } from "../../Signet/util";

const useStyles = makeStyles({
    container: {
        width: '100%',
    },
});

const DesignPatternEdit = props => {
    const classes = useStyles();
    const { permissions } = props;

    if (!permissions) return <Loading />;
    const permissionsList = permissions.split(",");

    return (
        <Edit {...props} className='overflow-visible'>
            <WithProps>
                {({ record, ...props }) =>
                (<SimpleForm record={record} {...props} undoable={false} toolbar={<EditToolBar delete={permissionsList.includes("delete_material_data")} />}>
                    <Grid container className={classes.container} justify="space-between">
                        <Grid item xs={5}>
                            <TextInput
                                source="name" label="Name" fullWidth disabled />
                        </Grid>
                        <Grid item xs={5}>
                            <TextInput
                                source="sku_code" label="Sku Code" fullWidth disabled />
                        </Grid>

                        <Grid item xs={5}>
                            <CustomBooleanInput source="is_inside" label="Is Inside" />
                        </Grid>

                        <Grid item xs={5}>
                            <CustomBooleanInput source="is_reverse" label="Is Reverse" />
                        </Grid>

                        <Grid item xs={5}>
                            <TextInput
                                source="netsuite_id" label="Netsuite ID" fullWidth />
                        </Grid>

                        <Grid item xs={5}>
                            <TextInput
                                source="netsuite_value" label="Netsuite Value" fullWidth />
                        </Grid>
                    </Grid>
                </SimpleForm>)
                }
            </WithProps>
        </Edit>
    )
};

export default DesignPatternEdit;

